/**
 * Get the environment property
 */
export function getEnvProperty(property: string) {
    const domainConfigs = require("../resources/environment/env.configs.json");
    const properties = require("../resources/environment/env.properties.json");
    let host = window.location.host.split(':')[0],
        config = domainConfigs[host],
        upc = config.upc,
        env = config.env,
        globalProp = properties[property],
        upcProp = properties[upc][property],
        envProp = properties[upc][env][property],
        prop = null;
    // check if the property is defined at the global lvl
    if (globalProp !== undefined) {
        prop = globalProp;
    }
    // check if the property is defined at the upc lvl and override or set
    if (upcProp !== undefined) {
        prop = upcProp;
    }
    // check if the property is defined at the upc environment lvl and override or set
    if (envProp !== undefined) {
        prop = envProp
    }

    return prop;
}

/**
 * Return user to login screen 
 */
export function returnToLogin() {
    const loginPath = getEnvProperty('LOGIN_PATH');
    window.parent.location.replace(loginPath);
}

/**
 * Get the portal-specific index page url
 * 
 * @returns string
 */
export function getHomePageUrl() {
    return "/webapps/groupaccess/Dispatch?application=org.bcbsal.inet.groupmgmt.GroupAppListApplication&handler=LiferayLoginHandler";
}

export default {
    getEnvProperty,
    returnToLogin,
    getHomePageUrl,
};